import BigNumber from 'bignumber.js';

const toBigNumber = value => {
    return new BigNumber(value.toString());
};

export const truncateAmount = amount => {
    if (!amount) return 0;

    // Créer un objet BigDecimal en utilisant une chaîne de caractères
    let bigDecimalAmount = toBigNumber(amount);

    // Tronquer le résultat à 2 décimales avec arrondi par défaut (vers le bas)
    let truncatedResult = bigDecimalAmount.decimalPlaces(2, BigNumber.ROUND_FLOOR);

    // Convertir le résultat en nombre
    return truncatedResult.toNumber();
};

export const plusAmount = (inital, amount) => {
    const cleanedInital = !inital ? 0 : inital;
    const cleanedAmount = !amount ? 0 : amount;

    // Créer un objet BigDecimal en utilisant une chaîne de caractères
    let bigDecimalInitial = toBigNumber(cleanedInital);
    let bigDecimalAmount = toBigNumber(cleanedAmount);

    // Effectuer l'addition
    let result = bigDecimalInitial.plus(bigDecimalAmount);

    // Convertir le résultat en nombre
    return result.toNumber();
};

export const minusAmount = (inital, amount) => {
    const cleanedInital = !inital ? 0 : inital;
    const cleanedAmount = !amount ? 0 : amount;

    // Créer un objet BigDecimal en utilisant une chaîne de caractères
    let bigDecimalInitial = toBigNumber(cleanedInital);
    let bigDecimalAmount = toBigNumber(cleanedAmount);

    // Effectuer la soustraction
    let result = bigDecimalInitial.minus(bigDecimalAmount);

    // Convertir le résultat en nombre
    return result.toNumber();
};

export const multiplyAmount = (inital, amount) => {
    const cleanedInital = !inital ? 0 : inital;
    const cleanedAmount = !amount ? 0 : amount;

    // Créer un objet BigDecimal en utilisant une chaîne de caractères
    let bigDecimalInitial = toBigNumber(cleanedInital);
    let bigDecimalAmount = toBigNumber(cleanedAmount);

    // Effectuer la soustraction
    let result = bigDecimalInitial.multipliedBy(bigDecimalAmount);

    // Convertir le résultat en nombre
    return result.toNumber();
};



// WEBPACK FOOTER //
// ./src/utils/mathUtils.js